import { LimitType } from "model/schema/globalTypes";
import { useMemo, useState } from "react";
import { ServiceProductFormProps } from "../ServiceProductForm";
import useCurrentUser from "./useCurrentUser";
import useFormSubmission from "./useFormSubmission";

const initialStateWithDefaults = {
  apiKeyId: "",
  limitType: LimitType.Soft,
  transactionLimit: 1000,
  services: [],
  name: "",
  startMonth: undefined,
  endMonth: undefined,
  periods: []
};

const useServiceProductForm = (props: ServiceProductFormProps) => {
  const { user, loading: userLoading } = useCurrentUser();
  const { submitForm } = useFormSubmission(props.onSubmit, props.solutionKey);
  const [singlePeriod, setSinglePeriod] = useState(true);
  const userEmail = user?.attributes.email;
  const initialValues = useMemo(
    () => ({
      ...initialStateWithDefaults,
      notificationTriggers: userEmail
        ? [{ email: userEmail, thresholds: [0.8, 1] }]
        : [],
      singlePeriod
    }),
    [userEmail, singlePeriod]
  );

  const handleSinglePeriodChange = (
    newValue: boolean,
    setFieldValue: (field: string, value: unknown) => void
  ) => {
    setSinglePeriod(newValue);
    setFieldValue("singlePeriod", newValue);
  };

  return {
    initialValues,
    submitForm,
    loading: userLoading,
    singlePeriod,
    handleSinglePeriodChange
  };
};

export default useServiceProductForm;
